import { groupTileInput } from '@utils/component-framework';
import { useOpgavekompleksetEntry } from '../../../../state/hook.entry.js';
import { useInputState } from '../../hook.use-input-state.js';
import { Tile } from '../atom.tile/_tile-input.js';
import { jsx } from 'react/jsx-runtime';

function GroupTile(props) {
  const entry = useOpgavekompleksetEntry({
    select: entry => groupTileInput.entry.asType(entry?.data.tasks[props.taskEntryKey]?.details[props.tile.id])
  });
  const defaultState = useInputState(props.tile, entry);
  const state = props.tile.options.fixed ? "fixed" : !props.state ? defaultState : props.state === "should-have" && defaultState === "correct" ? "correct" : props.state;
  return /*#__PURE__*/jsx(Tile, {
    tile: props.tile,
    state: state,
    isDraggable: !!props.isDraggable,
    isDragOverlay: !!props.isDragOverlay,
    facitTheme: "colored-backgrounds"
  });
}

export { GroupTile };
//# sourceMappingURL=atom.tile.js.map
